import React from "react";
import { useAppSelector } from "../../../store/storeHooks";
import { useLocation, useNavigate } from "react-router-dom";

export const LocationInformationPolicy = () => {
    return (
        <>
        <div className="contentBox">
            <h2>Terms of Service: Access to Location Information and Location-based Services</h2>
            <ol>
                <li>
                    <div className="titleBox">
                            <span>Article 1. Purpose</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The purpose of these Terms of Service is to define the rights, obligations, and other necessary matters arising between Fine Digital Inc. (the “Company”) and its customers when the Company, as a location information service provider, collects or provides location information to third parties through its products (e.g., a dash cam or door cam, hereinafter referred to as “device”) after receiving customers’ consent, or when the Company, as a location-based service provider, provides services through the devices or App.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 2. Application of Relevant Laws</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                These Terms of Service shall be applied fairly in accordance with the principle of good faith. For matters not specified in these Terms of Service, applicable laws or commercial practice shall apply.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 3. Effect and Change of Terms of Service</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    These Terms of Service take effect when the customer indicates consent to these Terms of Service by following the steps as instructed by the Company.
                                </li>
                                <li className="circle">
                                    By clicking “I agree” on the specified page on the FineVu website (www.finevu.com) or app, the customer acknowledges that they have read and understood these Terms of Service and that they thereby indicate consent.
                                </li>
                                <li className="circle">
                                    The Company can make changes to these Terms of Service within a scope in line with the Act on the Protection and Use of Location Information or other applicable laws when required to make changes to the Services.
                                </li>
                                <li className="circle">
                                    When making a revision of these Terms of Service, the Company notifies the customers by the below means on the revision date, grounds for revision, and contents of the current/revised Terms of Service. The customer is made aware that, by not indicating consent or rejection by the effective date of the revised Terms of Service, they indicate consent to the revised Terms of Service.
                                    <ul>
                                        <li className="hyphen">
                                            Notice on the FineVu website: From 14 days before the effective date of the revised Terms of Service to a date which allows ample time for customers to see the notice after the effective date
                                        </li>
                                        <li className="hyphen">
                                            Notice on the FineVu app: For the 14 days leading up to the effective date of the revised Terms of Service
                                        </li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    By not indicating consent to or rejection of the revised Terms of Service by the effective date of the revised Terms of Service despite having been notified of the revision by the Company, the customer indicates consent to the revised Terms of Service.
                                </li>
                                <li className="circle">
                                    When the customer fails to indicate consent to the revised Terms of Service, the Company or the customer can terminate the agreement for the use of the Services.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 4. Contact Information of the Company</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company's trade name and address are as follows.
                            </p>
                            <ul>
                                <li className="circle">Trade name: Fine Digital, Inc.</li>
                                <li className="circle">CEO: Kim Yong-hoon</li>
                                <li className="circle">Address: Level 7, 41 Seongnam-daero 925beon-gil (Fine Venture Building, Yatap-dong), Bundang-gu, Seongnam, Gyeonggi-do, South Korea</li>
                                <li className="circle">Phone number: 1588-4458</li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 5. Personal Location Information Collection Method, etc.</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    The method by which the Company collects personal location information, the purpose of retaining such information to provide location-based services, and the retention period are as follows:
                                    <div className="tableWrap">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Service name</th>
                                                    <th>Collection method</th>
                                                    <th>Purpose of retaining personal location information</th>
                                                    <th>Holding period</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>FineVu Connected SK</th>
                                                    <td>
                                                        <p className="borderCircle">Collection of devices’ GPS information</p>
                                                    </td>
                                                    <td>
                                                        <p className="borderCircle">Saving of previously taken routes for re-access</p>
                                                    </td>
                                                    <td>
                                                        <p className="borderCircle">Six months after collection</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>FineVu Cloud</th>
                                                    <td>
                                                        <p className="borderCircle">Collection of devices’ GPS information</p>
                                                    </td>
                                                    <td>
                                                        <p className="borderCircle">Real-time location checks, driving reports, etc.</p>
                                                    </td>
                                                    <td>
                                                        <p className="borderCircle">Six months after collection</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </li>
                                <li className="circle">
                                    In accordance with paragraph 2 of Article 16 of the Act on the Protection and Use of Location Information, etc., the Company automatically saves proof of the collection, use, and sharing of customers’ location information to a location information system, and retains this proof for a period of six months.
                                </li>
                                <li className="circle">
                                    Upon expiration of the specified customer location information holding period, the Company immediately deletes customer location information but retains the proof of the collection, use, and sharing of customer location information. However, the Company can hold customer location information for up to one year from the time of the customer’s consent in cases where such holding is mandated by law or the customer has separately given consent to the holding of location information.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 6. Personal Location Information Collection</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    Before collecting customer location information, the Company shall make the customer aware of such an activity through these Terms of Service and obtain consent of the customer (location information subject).
                                </li>
                                <li className="circle">
                                    A customer consenting to the collection of location information can withhold consent to a part or parts of the range of the collection of customer location information and of these Terms of Service.
                                </li>
                                <li className="circle">
                                    When collecting customer location information, the Company shall collect only the minimum required information to fulfill the purpose of collection.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 7. Use or Sharing of Customer Location Information</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    In accordance with Paragraph 1 or Paragraph 2 of Article 19 of the Act on the Protection and Use of Location Information, the Company can provide customer location information to location-based services providers with the customer’s consent. In such a case, the Company shall not refuse such provision without a valid reason.
                                </li>
                                <li className="circle">
                                    Location-based services providers shall provide the Company with the below information in requesting customer location information.
                                    <ul>
                                        <li className="hyphen">Verification of the customer’s consent</li>
                                        <li className="hyphen">Range and period of customer location information</li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    To provide the Services using the personal location information it has collected, the Company must first state this in the Terms of Service and then obtain the consent of the personal location information subject.
                                </li>
                                <li className="circle">
                                    In the case of providing personal location information to a third party designated by the subject of personal location information, the Company shall notify the subject of personal location information of the designated recipient of such information and the purpose of provision in advance and shall obtain his/her consent. The Company shall immediately notify, on each occasion, the subject of personal location information, of the designated recipient of such information, and the date, time, and purpose of such provision (“information provision details”) via the App, etc. However, the Company notifies the customer by email in any of the below cases.
                                    <ul>
                                        <li className="hyphen">
                                            The Terminal from which customer location information was collected is not equipped to receive text, voice, or video communications
                                        </li>
                                        <li className="hyphen">
                                            The customer has requested to be notified by a communication terminal other than the Terminal from which customer location information was collected, or by email
                                        </li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    If a member consents in accordance with Paragraphs 3 and 4, they may defer their consent for the purpose of information use/provision, the scope of the information recipient, and part of the terms and conditions for use of the location-based services, as well as for the notification method in the event of location information provision to a third party.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 8. Restrictions on Collection, Use, and Provision of Personal Location Information</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                Except when consented by the customer or in any of the below cases, the Company shall not use or share with a third party customer location information or proof of the collection/sharing of customer location information in excess of the range specified in these Terms of Service or notified to the customer.
                            </p>
                            <ol>
                                <li className="circle">
                                    When proof of the collection/sharing of customer location information is required for the settlement of charges for location-based services
                                </li>
                                <li className="circle">
                                    When customer location information is shared with personally identifiable information redacted for purposes such as statistical calculations, studies, or market research
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 9. Particulars and Usage Fees of Services</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    The particulars and usage fees of the services provided by the Company are as follows:
                                    <div className="tableWrap">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Provided</th>
                                                    <th>Charge structure</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>FineVu Connected SK</th>
                                                    <td>
                                                        <p className="borderCircle">Saving of previously taken routes for re-access</p>
                                                    </td>
                                                    <td>
                                                        <p className="borderCircle">Refer to the terms and conditions for use of FineVu Connected SK.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>FineVu Cloud</th>
                                                    <td>
                                                        <p className="borderCircle">Real-time location checks, driving reports, etc.</p>
                                                    </td>
                                                    <td>
                                                        <p className="borderCircle">Refer to the terms and conditions for use of FineVu Cloud.</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </li>
                                <li className="circle">
                                    The Company shall charge fees for paid services, using the method determined by the electronic payment company with which the Company has a contract.
                                </li>
                                <li className="circle">
                                    Cancellation and refund of fees for paid services are subject to the terms and conditions for use of each service and the relevant laws.
                                </li>
                                <li className="circle">
                                    Any request for refunds or payment information due to a customer's personal information theft or payment fraud may be rejected, except in cases provided for by law.
                                </li>
                                <li className="circle">
                                    Data communication fees incurred when using wireless services are separate and are subject to the policies of the mobile carrier to which the member is subscribed.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Articlel 10. Addition or Modification of Services</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company issues a notice in accordance with Paragraph 4 of Article 2 when additions or changes to the Services are to be made. Such additions or changes will then be reflected in Article 9.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 11. Restriction or Suspension of the Use of the Services</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    When the Company’s operating conditions, including any changes to internal policies, or legal issues prevent the Company from maintaining the Services, the Company can restrict, modify, or suspend the Services in part or entirety.
                                </li>
                                <li className="circle">
                                    When the Company restricts or suspends the Services in accordance with the preceding paragraph, the Company makes public the reason for and period of the restriction or suspension on the FineVu website or app.
                                </li>
                                <li className="circle">
                                    When the Company has a valid reason preventing it from making public the information specified in the preceding paragraph, the Company can make public the information at a later time.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 12. Rights of the Location Information Subject and Their Exercise</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    The customer can at any time withdraw in part or full their consent to the collection and sharing of location information by the Company, or their consent to the Company’s provision of location-based services and sharing of location information with third parties. However, the withdrawal of consent in part or full can prevent the customer from continuing to use the Services provided by the Company.
                                </li>
                                <li className="circle">
                                    When the customer withdraws consent in full as specified in Paragraph 1, the Company deletes the customer’s location information and proof of the use or sharing of the customer’s location information. However, when the customer withdraws consent in part only, only the customer’s location information and proof of the use or sharing of the customer’s location information commensurate with the withdrawal of consent are deleted.
                                </li>
                                <li className="circle">
                                    The customer can at any time demand that the Company suspend the use or sharing of location information. The Company shall not deny such a demand, and has the technology necessary to make such a suspension.
                                </li>
                                <li className="circle">
                                    The customer can demand from the Company viewing or access of any of the following information, and can demand the correction of any errors in any of the following information. In such a case, the Company shall not deny such a demand without a valid reason.
                                    <ul>
                                        <li className="hyphen">Proof of the use or sharing of customer location information</li>
                                        <li className="hyphen">Reason for the sharing of customer location information with a third party in accordance with the Act on the Protection and Use of Location Information or other laws, and the details of such information shared</li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    The customer can exercise the rights specified in Paragraph 1 or 4 through Fine Digital’s customer service center.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 13. Rights/Obligations Held by the Legal Guardians of Children of Eight Years Old or Younger, etc</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    Where the legal guardian of any of the following persons (“child of eight years old or younger, etc.”) gives consent to the collection or provision of personal location information regarding the child of eight years old or younger, etc., for the protection of the child’s life or body, the Company shall deem that the child themselves consent thereto. The services provided by the Company are intended for drivers of automobiles or other vehicles. Customers under 14 years of age as defined in the Road Traffic Act or customers who are disqualified from holding a driver's license as defined in Article 82 of the Road Traffic Act, etc. are not entitled to use the Services.
                                    <ul>
                                        <li className="hyphen">A child of eight years old or younger</li>
                                        <li className="hyphen">A person under adult guardianship</li>
                                        <li className="hyphen">
                                            A person with a mental disorder defined in subparagraph 2 under Paragraph 2 of Article 2 of the Act on Welfare of Persons with Disabilities, classified as a person with a severe disability defined in subparagraph 2 of Article 2 of the Act on the Employment Promotion and Vocational Rehabilitation for Persons with Disabilities (limited to those registered as disabled persons under Article 32 of the Act on Welfare of Persons with Disabilities)
                                        </li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    A legal guardian of a child of eight years old or younger, pursuant to Paragraph 1, refers to a person who actually cares for a child of eight years old or younger and falls under any of the following subparagraphs:
                                    <ul>
                                        <li className="hyphen">
                                            A legal representative of a child of eight years old or younger, or a guardian defined in Article 3 of the Act on the Guardianship of Minors in Protective Facilities
                                        </li>
                                        <li className="hyphen">A legal representative of an adult ward of court</li>
                                        <li className="hyphen">
                                            The legal representative of a person under subparagraph 3 of Paragraph 1 herein, the head of a residential facility for handicapped people under subparagraph 1 of Paragraph 1 of Article 58 of the Act on Welfare of Persons with Disabilities (limited to facilities established and operated by the state or local government), the head of a mental health facility under Article 22 of the Act on the Improvement of Mental Health and the Support for Welfare Services for Mental Patients, or the head of a mental rehabilitation facility under Article 26 of the aforesaid Act (limited to facilities established and operated by the state or local government)
                                        </li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    For the protection of a child of eight years old or younger, etc., the legal guardian who intends to consent in accordance with Paragraph 1 must submit to the Company a written consent with the name and seal or the signature, along with a written document proving that he/she is the legal guardian. The written consent must include the following information:
                                    <ul>
                                        <li className="hyphen">The name, address and date of birth of the child of eight years old or younger, etc.</li>
                                        <li className="hyphen">The name, address and contact information of the legal guardian</li>
                                        <li className="hyphen">Statement that the purpose of collecting or providing the personal location information is limited to protection of the life or body of the child of eight years old or younger, etc.</li>
                                        <li className="hyphen">The date of consent</li>
                                    </ul>
                                </li>
                                <li className="circle">
                                    A legal guardian giving consent to the collection and provision of personal location information of a child of eight years old or younger, etc. may exercise all of the member rights defined in Article 12.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 14. Rights Held by Legal Representatives</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    Where the Company intends to collect or provide personal location information of a member under 14 years of age, the Company shall obtain the consent of the member and his/her legal representative. The legal representative is entitled to all the member rights set forth in Article 12. The services provided by the Company are intended for drivers of automobiles or other vehicles. Customers under 14 years of age as defined in the Road Traffic Act or customers who are disqualified from holding a driver's license as defined in Article 82 of the Road Traffic Act, etc. are not entitled to use the Services.
                                </li>
                                <li className="circle">
                                    The Company shall verify that the legal representative has consented, using a method that falls under one of the following subparagraphs:
                                    <ul>
                                        <li className="hyphen">
                                            The Company sets up so that the legal representative consents to the agreement posted at the relevant website, and notifies the legal representative via mobile text message that the location information service provider, etc. has confirmed the consent
                                        </li>
                                        <li className="hyphen">
                                            The Company sets up so that the legal representative consents to the agreement posted at the relevant website, and is provided with information on the legal representative’s credit card or debit card information
                                        </li>
                                        <li className="hyphen">
                                            The Company sets up so that the legal representative consents to the agreement posted at the relevant website, and verifies the legal representative’s identity through mobile authentication, etc.
                                        </li>
                                        <li className="hyphen">
                                            The Company hands over a written agreement to the legal representative or sends it by post or fax, so that the legal representative signs and seals the agreement and submits it
                                        </li>
                                        <li className="hyphen">
                                            The Company sends an e-mail containing the agreement to the legal representative and receives a reply expressing his/her consent
                                        </li>
                                        <li className="hyphen">
                                            The Company informs the legal representative of the agreement by phone and obtains consent, or provides a method for viewing the agreement, such as the relevant website address, and then obtains consent by phone
                                        </li>
                                        <li className="hyphen">
                                            The Company informs the legal representative of the agreement using a method equivalent to the methods prescribed in subparagraphs 1 through 6, and confirms his/her expression of intent to consent
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 15. Location Information Manager</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    The Company shall appoint the location information manager from among the persons who are in a position to take actual responsibility for properly managing and protecting location information and smoothly handling complaints from personal location information subjects.
                                </li>
                                <li className="circle">
                                    The location information manager is the head of the department that collects and provides location information, and shall observe the Addendum to these Terms of Service.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 16. Compensation for Damage</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                Where a customer suffers damage because the Company has violated Article 15 or 26 of the Act on the Protection and Use of Location Information, etc., he/she may claim damages against the Company. The Company cannot be exonerated from said obligation unless it can disprove its accountability, intentional or not.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 17. Exemptions</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    The Company is exempt from accountability for the collection of customer location information when it is unable to collect customer location information due to natural disasters and other instances of force majeure.
                                </li>
                                <li className="circle">
                                    The Company is not accountable for difficulty experienced by the customer in the use of the Services resulting from the Company’s inability to collect customer location information or incorrect collection of customer location information caused by a fault on the part of the customer.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 18. Settlement of Disputes</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    If the parties concerned fail to reach an agreement regarding a dispute related to location information or cannot reach an agreement, the Company may apply for arbitration to the Korea Communications Commission in accordance with Article 28 of the Act on the Protection and Use of Location Information, etc.
                                </li>
                                <li className="circle">
                                    If the parties concerned fail to reach an agreement regarding a dispute related to location information or cannot reach an agreement, the Company or the member concerned may apply for mediation to the Personal Information Dispute Mediation Committee in accordance with Article 43 of the Personal Information Protection Act.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                            <span>Article 19. Governing Law and Jurisdiction</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                    These Terms of Service are governed by and construed in accordance with the laws of the Republic of Korea.
                                </li>
                                <li className="circle">
                                    The rights held by users and legal representatives and the method for exercising those rights are determined based on the address of the user concerned at the time of filing a lawsuit. If the user does not have an address, the local court with jurisdiction over the user’s place of residence has exclusive jurisdiction. If the user's address or residence is not clear at the time of filing the lawsuit or if the user resides abroad, the lawsuit shall be filed in the competent court under the Civil Procedure Act.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>

                 <li>
                    <div className="titleBox">
                            <span>Addenda</span>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <ol>
                                <li className="circle">
                                These Terms of Service shall be effective as of July 15, 2025.
                                </li>
                                <li className="circle">
                                The location information manager defined in Article 15 of these Terms of Service shall be the head of the Online Marketing division at the business headquarters.
                                </li>
                            </ol>
                        </div>
                    </div>
                </li>
            </ol>
            
        </div>
        </>
    )
}